import React, {FC, useEffect, useState} from "react";
import {CardMedia, IconButton, Typography} from "@material-ui/core";
import FlexBox from "view/components/Layout/FlexBox";
import {RawAttachmentFile} from "ts/api/attachmentFile";
import axios from "axios";
import clsx from "clsx";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DeleteIcon from "@material-ui/icons/Delete";
import FfairTooltip from "view/components/Layout/Tooltip";
import {IFile} from "@evennt-tech/api-v2-core";
import useStyles from "./styles";

type Props = {
  file: IFile | RawAttachmentFile;
  handleRemoveFile: () => void;
  classes?: {
    fileName?: string;
  };
};

export async function getFileType(url: string) {
  try {
    const response = await axios.get(url, {responseType: "blob"});
    return response.data.type;
  } catch (error) {
    console.error("Error fetching file type:", error);
    return null;
  }
}

const FilePreview: FC<Props> = ({
  file,
  handleRemoveFile,
  classes: propsClasses,
}) => {
  const classes = useStyles();
  const [fileType, setFileType] = useState<string | null>(null);

  useEffect(() => {
    async function fetchFileType() {
      if (file?.url) {
        const type = await getFileType(file.url);
        setFileType(type);
      }
    }

    fetchFileType();
  }, [file.url]);

  return (
    <FlexBox alignCenter className={classes.filePreview}>
      <FlexBox alignCenter>
        {fileType !== "application/pdf" ? (
          <CardMedia
            component="img"
            image={file.url}
            alt="Signature preview"
            className={classes.fileImage}
          />
        ) : (
          <PictureAsPdfIcon className={classes.fileImage} />
        )}
        <FfairTooltip title={file.title}>
          <Typography
            className={clsx(propsClasses?.fileName, classes.fileName)}
          >
            {file.title}
          </Typography>
        </FfairTooltip>
      </FlexBox>
      <IconButton onClick={handleRemoveFile}>
        <DeleteIcon />
      </IconButton>
    </FlexBox>
  );
};

export default FilePreview;
